import { z } from 'zod';

export const CareDocumentResourceSchema = z.object({
  type: z.string().min(1),
  name: z.string().min(1),
  link: z.string().min(1),
});

export type CareDocumentResource = z.infer<typeof CareDocumentResourceSchema>;
